
webpack.register(
    'modules/pill/pill',
    function() {
        return import('modules/pill/pill');
    },
    true
);